import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@/modules/common/components/Button';
import '../styles/DialogConfirmation.scss';

const DialogConfirmation = (props) => {
    return (
        <Dialog className="dialog-confirmation" open={props.open} onClose={props.onClose}>
            <DialogTitle>Подтверждение действия</DialogTitle>
            <DialogActions>
                <Button color="default" variant="text" onClick={props.onClose}>Отмена</Button>
                <Button onClick={props.onAccept} disabled={props.disabled}
                        autoFocus={true}
                >
                    Подтвердить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmation.propTypes = {
    open: PropTypes.bool.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default DialogConfirmation;
